import {Link}  from "gatsby"
import React,{ useEffect, useState } from "react";
import {Button, Form, Container, Row, Col,Fade,Dropdown} from 'react-bootstrap';
import  './Filter.scss';

const Filter = ({ bedrooms, minprice, maxprice, propertytype, bedroomsSelect, minpriceSelect, maxpriceSelect, propertyTypeSelect, handleSubmit, showHide, bedroomOpts, maxPriceOpts, minPriceOpts, propertyTypeOpts,setSearchString }) => {
    const [searchstring, updateString] = React.useState(setSearchString);
    function clearLocation(){
        if(typeof window != undefined){
        document.getElementById("location-keyword").value = "";
        }
    }
    return (
        <Container>
            <Row>
                <Col xl="12">
                    <div className="filter-title">
                        <button className="btn-back" onClick={showHide}>
                            <i className="icon-back"></i>
                        </button>
                        <h3>filter results</h3>
                    </div>
                </Col>
                
                <Col xl="12">
                    <Form onSubmit={e => e.preventDefault()}>
                        <Form.Group className="search-input">
                            <Form.Control 
                               type="text"
                               id="location-keyword"
                               placeholder="Location or keyword"
                               value={searchstring}
                               onChange={(e) => setSearchString(e.target.value)}
                            />
                            <span className="close-btm"><i className="icon-dark-close" onClick={clearLocation}></i></span>
                        </Form.Group>
                        <Dropdown onSelect={bedroomsSelect} className="select-option">
                            <Dropdown.Toggle id="bedrooms-m">
                                {bedrooms}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {bedroomOpts.map(each => 
                                        <Dropdown.Item className="cursor-pointer" eventKey={each.value}>{each.label}</Dropdown.Item>
                                    )}
                                </Dropdown.Menu>                                                                                
                        </Dropdown>
                        <Dropdown onSelect={minpriceSelect} className="select-option">
                            <Dropdown.Toggle id="minprice-m">
                                {minprice}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {minPriceOpts.map(each => 
                                    <Dropdown.Item className="cursor-pointer" eventKey={each.value}>{each.label}</Dropdown.Item>
                                )}
                            </Dropdown.Menu>                                                                                
                        </Dropdown>
                        <Dropdown onSelect={maxpriceSelect} className="select-option">
                            <Dropdown.Toggle id="maxprice-m">
                                {maxprice}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {maxPriceOpts.map(each => 
                                    <Dropdown.Item className="cursor-pointer" eventKey={each.value}>{each.label}</Dropdown.Item>
                                )}
                            </Dropdown.Menu>                                                                                
                        </Dropdown>
                        <Dropdown onSelect={maxpriceSelect} className="select-option">
                            <Dropdown.Toggle id="propertytyoe-m">
                                {propertytype}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {propertyTypeOpts.map(each => 
                                    <Dropdown.Item className="cursor-pointer" eventKey={each.value}>{each.label}</Dropdown.Item>
                                )}
                            </Dropdown.Menu>                                                                                
                        </Dropdown>
                        <button type="button" onClick={handleSubmit} className="search-btn btn">update results</button>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default Filter;

